import * as React from 'react';
const SvgSlashForward = (props) => (React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
    React.createElement("path", { d: "M6.686 22a.937.937 0 0 1-.808-1.41L16.503 2.464a.938.938 0 0 1 1.619.948L7.497 21.539a.936.936 0 0 1-.81.462Z", fill: "currentColor" })));
export default SvgSlashForward;
